export default __webpack_public_path__ + "static/media/fondo-login.cb08791e.png";